(function () {
  function initAcc() {
    document.querySelectorAll('.lk-acc__head').forEach(function (h) {
      if (h.dataset.lkB) return;
      h.dataset.lkB = '1';
      h.addEventListener('click', function () {
        var o = h.parentNode.classList.toggle('on');
        h.setAttribute('aria-expanded', o ? 'true' : 'false');
      });
    });
  }
  function initDesc() {
    document.querySelectorAll('[data-lk-desc]').forEach(function (d) {
      if (d.dataset.lkB) return;
      d.dataset.lkB = '1';
      var wrap = d.closest('.lk-pd__desc-wrap');
      if (!wrap) return;
      var b = wrap.querySelector('[data-lk-more]');
      if (!b) return;
      var root = d.closest('.lk-pd');
      var lines = (root && parseInt(root.getAttribute('data-lk-lines'), 10)) || 3;
      var lh = parseFloat(getComputedStyle(d).lineHeight) || 22;
      var c = Math.round(lh * lines);
      if (d.scrollHeight - 2 > c) {
        d.style.maxHeight = c + 'px';
        d.classList.add('is-clamped');
        b.hidden = false;
        var l = b.querySelector('[data-lk-more-label]');
        var o = false;
        b.addEventListener('click', function () {
          o = !o;
          if (o) {
            d.style.maxHeight = d.scrollHeight + 'px';
            d.classList.remove('is-clamped');
            b.classList.add('is-open');
            b.setAttribute('aria-expanded', 'true');
            if (l) l.textContent = 'Voir moins';
          } else {
            d.style.maxHeight = c + 'px';
            d.classList.add('is-clamped');
            b.classList.remove('is-open');
            b.setAttribute('aria-expanded', 'false');
            if (l) l.textContent = 'Voir plus';
          }
        });
      }
    });
  }
  function A() { initAcc(); initDesc(); }
  if (document.readyState !== 'loading') A();
  else document.addEventListener('DOMContentLoaded', A);
  document.addEventListener('shopify:section:load', A);
})();

/* Galerie produit — hauteur adaptative.
 * En mode carousel + "adapt", Horizon cale la hauteur de la piste sur l'image la plus haute,
 * ce qui letterboxe (bandes blanches) les images d'une autre orientation. Ici on fait suivre
 * le cadre a l'image affichee : on partage le ratio de la slide active sur toutes les slides
 * (via --lk-active-ratio + la classe .lk-adapt). N'agit que si les images ont des ratios differents.
 *
 * IMPORTANT : au changement de variante, Horizon re-rend la galerie via son propre moteur
 * (section-renderer + morph). Ni DOMContentLoaded ni shopify:section:load ne se declenchent,
 * et le re-render efface la classe .lk-adapt + la variable --lk-active-ratio posees ici.
 * On re-applique donc sur les evenements du theme (voir assets/events.js : variant:update,
 * slideshow:select) et via un MutationObserver sur la galerie, en filet de securite. */
(function () {
  var raf = window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : function (f) { return setTimeout(f, 16); };

  // WeakSet plutot qu'un data-attribut : morph reecrit les attributs depuis le HTML serveur
  // et effacerait un marqueur pose dans le DOM (on rebinderait alors en double).
  var obsBound = new WeakSet();
  var scrollBound = new WeakSet();
  var pending = false;

  function slideRatio(slide) {
    // Each image's aspect ratio lives on the inner .product-media as --ratio.
    var pm = slide.querySelector('.product-media');
    if (!pm) return 0;
    var r = parseFloat(getComputedStyle(pm).getPropertyValue('--ratio'));
    return (r && isFinite(r)) ? r : 0;
  }

  function reset(gallery) {
    gallery.classList.remove('lk-adapt');
    gallery.style.removeProperty('--lk-active-ratio');
  }

  function update(gallery) {
    if (!gallery.classList.contains('media-gallery--carousel')) { reset(gallery); return; }
    var scroller = gallery.querySelector('slideshow-slides');
    if (!scroller) { reset(gallery); return; }

    var slides = scroller.querySelectorAll(':scope > slideshow-slide');
    if (slides.length < 2) { reset(gallery); return; }

    // Pick the slide closest to the viewport center (robust to cloned/infinite slides).
    var srect = scroller.getBoundingClientRect();
    var center = srect.left + srect.width / 2;
    var firstRatio = null;
    var differ = false;
    var bestRatio = null;
    var bestDist = Infinity;
    for (var i = 0; i < slides.length; i++) {
      var r = slideRatio(slides[i]);
      if (!r) continue;
      if (firstRatio === null) firstRatio = r;
      else if (Math.abs(r - firstRatio) > 0.01) differ = true;
      var rect = slides[i].getBoundingClientRect();
      if (rect.width === 0) continue;
      var d = Math.abs(rect.left + rect.width / 2 - center);
      if (d < bestDist) { bestDist = d; bestRatio = r; }
    }
    // Only act when there are mixed orientations (otherwise leave the native layout).
    if (firstRatio === null || !differ || bestRatio === null) { reset(gallery); return; }
    gallery.classList.add('lk-adapt');
    gallery.style.setProperty('--lk-active-ratio', bestRatio);
  }

  function bind(gallery) {
    if (!obsBound.has(gallery)) {
      obsBound.add(gallery);
      // childList/subtree uniquement : update() ne touche que class + style (attributs),
      // donc aucune boucle possible avec cet observer.
      new MutationObserver(schedule).observe(gallery, { childList: true, subtree: true });
    }
    // Le scroller peut avoir ete remplace par le re-render : on rebinde sur le nouveau noeud.
    var scroller = gallery.querySelector('slideshow-slides');
    if (scroller && !scrollBound.has(scroller)) {
      scrollBound.add(scroller);
      var ticking = false;
      scroller.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        raf(function () { update(gallery); ticking = false; });
      }, { passive: true });
    }
  }

  function run() {
    document.querySelectorAll('media-gallery').forEach(function (g) { bind(g); update(g); });
  }

  function schedule() {
    if (pending) return;
    pending = true;
    // Double rAF : laisse le re-render puis le layout se poser avant de mesurer.
    raf(function () { raf(function () { pending = false; run(); }); });
  }

  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', run);

  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('slideshow:select', schedule);
  window.addEventListener('resize', schedule, { passive: true });
  document.addEventListener('variant:update', function () {
    schedule();
    // 2e passe : apres le re-render, Horizon fait defiler la galerie jusqu'au media
    // de la variante. On remesure une fois ce defilement termine.
    setTimeout(run, 300);
  });
})();
